import { Box } from '@mui/material';
import { HeaderCellProps } from '../types';

export const TeamNameHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <Box sx={{ textAlign: 'left' }}>Team Name</Box>;
};
